import { render } from "./BadgeSoon.vue?vue&type=template&id=a7e6609e&ts=true"
import script from "./BadgeSoon.vue?vue&type=script&lang=ts"
export * from "./BadgeSoon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__